module.exports = __webpack_public_path__ + "img/ru.8154f9e6.svg";